<app-titled-page heading="Asignaciones">
  <router-outlet></router-outlet>
</app-titled-page>
